import {startYear} from "../../consts/consts";

class HscPipelineColumns {
    status;
    properties;
    loanAmount;
    totalGrossFee;
    referral;
    credits;
    bankBonus;
    hscFee;
    url;

    constructor({data, key, transactionYear}) {
        switch (key) {
            /* case 'COURTING':
                this.status = 'Courting';
                break; */
            case 'LOAN':
                this.status = 'Loan In Process';
                break;
            case 'CLOSED_YTD':
                this.status = 'Closed YTD';
                this.url = 'closed-ytd';
                break;
            case 'CLOSED_ONE_YEAR_AGO':
                this.status = `Closed - ${transactionYear - 1}`;
                this.url = `closed-${transactionYear - 1}`;
                break;
            case 'CLOSED_TWO_YEARS_AGO':
                this.status = `Closed - ${transactionYear - 2}`;
                this.url = `closed-${transactionYear - 2}`;
                break;
            case 'CLOSED_THREE_YEARS_AGO':
                this.status = `Closed - ${transactionYear - 3}`;
                this.url = `closed-${transactionYear - 3}`;
                break;
            case 'CLOSED_FOUR_YEARS_AGO':
                this.status = `Closed - ${transactionYear - 4}`;
                this.url = `closed-${transactionYear - 4}`;
                break;
            case 'CLOSED_FIVE_YEARS_AGO':
                this.status = `Closed - ${transactionYear - 5}`;
                this.url = `closed-${transactionYear - 5}`;
                break;
            case 'CLOSED_SIX_YEARS_AGO':
                this.status = `Closed - ${transactionYear - 6}`;
                this.url = `closed-${transactionYear - 6}`;
                break;
            case 'CLOSED_SEVEN_YEARS_AGO':
                this.status = `Closed - ${transactionYear - 7}`;
                this.url = `closed-${transactionYear - 7}`;
                break;
        }
        this.properties = data && data[`${key}_PROPERTIES`] ? data[`${key}_PROPERTIES`] : 0;
        this.loanAmount = data && data[`${key}_LOAN_AMOUNT`] ? data[`${key}_LOAN_AMOUNT`] : 0;
        this.totalGrossFee = data && data[`${key}_GROSS_FEE_HSC_TEAM_MEMBER_1`] && data[`${key}_GROSS_FEE_HSC_TEAM_MEMBER_2`] ? (parseFloat(data[`${key}_GROSS_FEE_HSC_TEAM_MEMBER_1`]) || 0) + (parseFloat(data[`${key}_GROSS_FEE_HSC_TEAM_MEMBER_2`]) || 0): data && data[`${key}_GROSS_FEE`] ? data[`${key}_GROSS_FEE`] : 0;
        this.referral = data && data[`${key}_REFERRAL`] ? data[`${key}_REFERRAL`] : 0;
        this.credits = data && data[`${key}_CREDITS`] ? data[`${key}_CREDITS`] : 0;
        this.bankBonus = data && data[`${key}_BANK_BONUS`] ? data[`${key}_BANK_BONUS`] : 0;
        this.hscFee = data && ((parseFloat(data[`${key}_GROSS_FEE`]) || 0) - (parseFloat(data[`${key}_REFERRAL`]) || 0) - (parseFloat(data[`${key}_CREDITS`]) || 0) + (parseFloat(data[`${key}_BANK_BONUS`]) || 0)) 
    }
}

export class HscPipelineModel {
   // courting;
    loanInProcess;
    closedYTD;
    closedOneYearAgo;
    closedTwoYearsAgo;
    closedThreeYearsAgo;
    closedFourYearsAgo;
    closedFiveYearsAgo;
    closedSixYearsAgo;
    closedSevenYearsAgo;
    closedTotal;

    constructor(data) {
        const transactionYear = new Date().getFullYear();
       // this.courting = new HscPipelineColumns({data, key: 'COURTING'});
        this.loanInProcess = new HscPipelineColumns({data, key: 'LOAN'});
        this.closedYTD = new HscPipelineColumns({data, key: 'CLOSED_YTD'});
        this.closedOneYearAgo = new HscPipelineColumns({data, key: 'CLOSED_ONE_YEAR_AGO', transactionYear});
        this.closedTwoYearsAgo = new HscPipelineColumns({data, key: 'CLOSED_TWO_YEARS_AGO', transactionYear});
        this.closedThreeYearsAgo = new HscPipelineColumns({data, key: 'CLOSED_THREE_YEARS_AGO', transactionYear});
        this.closedFourYearsAgo = new HscPipelineColumns({data, key: 'CLOSED_FOUR_YEARS_AGO', transactionYear});
        this.closedFiveYearsAgo = new HscPipelineColumns({data, key: 'CLOSED_FIVE_YEARS_AGO', transactionYear});
        if (transactionYear - 6 >= startYear)
            this.closedSixYearsAgo = new HscPipelineColumns({data, key: 'CLOSED_SIX_YEARS_AGO', transactionYear});
        if (transactionYear - 7 >= startYear)
            this.closedSevenYearsAgo = new HscPipelineColumns({data, key: 'CLOSED_SEVEN_YEARS_AGO', transactionYear});

    
        this.closedTotal = {}
        const safeValue = (obj, key) => (obj && obj[key] != null ? parseFloat(obj[key]) : 0);

        this.closedTotal['properties'] =
        safeValue(this.closedYTD, 'properties') +
        safeValue(this.closedOneYearAgo, 'properties') +
        safeValue(this.closedTwoYearsAgo, 'properties') +
        safeValue(this.closedThreeYearsAgo, 'properties') +
        safeValue(this.closedFourYearsAgo, 'properties') +
        safeValue(this.closedFiveYearsAgo, 'properties') +
        safeValue(this.closedSixYearsAgo, 'properties') +
        safeValue(this.closedSevenYearsAgo, 'properties');

        this.closedTotal['loanAmount'] =
        safeValue(this.closedYTD, 'loanAmount') +
        safeValue(this.closedOneYearAgo, 'loanAmount') +
        safeValue(this.closedTwoYearsAgo, 'loanAmount') +
        safeValue(this.closedThreeYearsAgo, 'loanAmount') +
        safeValue(this.closedFourYearsAgo, 'loanAmount') +
        safeValue(this.closedFiveYearsAgo, 'loanAmount') +
        safeValue(this.closedSixYearsAgo, 'loanAmount') +
        safeValue(this.closedSevenYearsAgo, 'loanAmount');

        this.closedTotal['totalGrossFee'] =
        safeValue(this.closedYTD, 'totalGrossFee') +
        safeValue(this.closedOneYearAgo, 'totalGrossFee') +
        safeValue(this.closedTwoYearsAgo, 'totalGrossFee') +
        safeValue(this.closedThreeYearsAgo, 'totalGrossFee') +
        safeValue(this.closedFourYearsAgo, 'totalGrossFee') +
        safeValue(this.closedFiveYearsAgo, 'totalGrossFee') +
        safeValue(this.closedSixYearsAgo, 'totalGrossFee') +
        safeValue(this.closedSevenYearsAgo, 'totalGrossFee');

        this.closedTotal['referral'] =
        safeValue(this.closedYTD, 'referral') +
        safeValue(this.closedOneYearAgo, 'referral') +
        safeValue(this.closedTwoYearsAgo, 'referral') +
        safeValue(this.closedThreeYearsAgo, 'referral') +
        safeValue(this.closedFourYearsAgo, 'referral') +
        safeValue(this.closedFiveYearsAgo, 'referral') +
        safeValue(this.closedSixYearsAgo, 'referral') +
        safeValue(this.closedSevenYearsAgo, 'referral');

        this.closedTotal['credits'] =
        safeValue(this.closedYTD, 'credits') +
        safeValue(this.closedOneYearAgo, 'credits') +
        safeValue(this.closedTwoYearsAgo, 'credits') +
        safeValue(this.closedThreeYearsAgo, 'credits') +
        safeValue(this.closedFourYearsAgo, 'credits') +
        safeValue(this.closedFiveYearsAgo, 'credits') +
        safeValue(this.closedSixYearsAgo, 'credits') +
        safeValue(this.closedSevenYearsAgo, 'credits');

        this.closedTotal['bankBonus'] =
        safeValue(this.closedYTD, 'bankBonus') +
        safeValue(this.closedOneYearAgo, 'bankBonus') +
        safeValue(this.closedTwoYearsAgo, 'bankBonus') +
        safeValue(this.closedThreeYearsAgo, 'bankBonus') +
        safeValue(this.closedFourYearsAgo, 'bankBonus') +
        safeValue(this.closedFiveYearsAgo, 'bankBonus') +
        safeValue(this.closedSixYearsAgo, 'bankBonus') +
        safeValue(this.closedSevenYearsAgo, 'bankBonus');

        this.closedTotal['hscFee'] =
        safeValue(this.closedYTD, 'hscFee') +
        safeValue(this.closedOneYearAgo, 'hscFee') +
        safeValue(this.closedTwoYearsAgo, 'hscFee') +
        safeValue(this.closedThreeYearsAgo, 'hscFee') +
        safeValue(this.closedFourYearsAgo, 'hscFee') +
        safeValue(this.closedFiveYearsAgo, 'hscFee') +
        safeValue(this.closedSixYearsAgo, 'hscFee') +
        safeValue(this.closedSevenYearsAgo, 'hscFee');

        this.closedTotal['status'] = 'Total Closed'
        this.closedTotal['url'] = 'total-closed'
    }
}